import { render } from "./bucket.vue?vue&type=template&id=cfb46fb4"
import script from "./bucket.vue?vue&type=script&lang=js"
export * from "./bucket.vue?vue&type=script&lang=js"

import "./bucket.vue?vue&type=style&index=0&id=cfb46fb4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__